import { initZanalytics } from '@zillow/universal-analytics';
import { isServerSide } from 'src/utils/validators/isServerSide';
import * as ApplicationConfigurationService from 'src/services/config/ApplicationConfigurationService.client';
import { initializeClickstreamLogger } from './utils/initializeClickstreamLogger';

export const initializeClickstream = () => {
    if (isServerSide()) {
        // eslint-disable-next-line no-console
        console.warn(
            'initializeClickstream called while window was undefined. Did you accidentally call this server-side?'
        );
        return;
    }
    const config = ApplicationConfigurationService.ConfigProvider.getInstance();
    initializeClickstreamLogger(config.runtimeConfig.isLowerEnvironment);
    initZanalytics(
        window,
        document,
        config.clickstreamConfig.sdkConfiguration,
        undefined,
        config.clickstreamConfig.clickstreamSDK
    );
};
